(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const closeIcon = document.getElementById('mobile-facets-close');
    const drawerContainer = document.querySelector('.mobile-facets__wrapper details');
    const summary = drawerContainer ? drawerContainer.querySelector('summary') : null;
    
    if (closeIcon && summary) {
      closeIcon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (drawerContainer.hasAttribute('open') && summary) {
          summary.click();
        }
      });
    }
    
    function animateSubmenu(detailsElement, isOpening) {
      const submenu = detailsElement.querySelector('.ec-submenu');
      if (!submenu) return;

      detailsElement.classList.remove('ec-opening', 'ec-closing');

      function handleTransitionEnd(e) {
        if (e.propertyName !== 'max-height' && e.propertyName !== 'opacity') return;
        
        if (e.propertyName === 'max-height') {
          detailsElement.classList.remove('ec-opening', 'ec-closing');
          
          if (!detailsElement.hasAttribute('open')) {
            submenu.style.maxHeight = '';
            submenu.style.opacity = '';
          }
        }
      }
      
      submenu.removeEventListener('transitionend', handleTransitionEnd);
      submenu.addEventListener('transitionend', handleTransitionEnd);

      if (isOpening) {
        detailsElement.classList.add('ec-opening');
        
        submenu.style.maxHeight = 'none';
        submenu.style.opacity = '0';
        const height = submenu.scrollHeight;
        submenu.style.maxHeight = '0';
        
        submenu.offsetHeight;
        
        requestAnimationFrame(function() {
          submenu.style.maxHeight = height + 'px';
          submenu.style.opacity = '1';
        });
      } else {
        detailsElement.classList.add('ec-closing');
        
        const height = submenu.scrollHeight;
        submenu.style.maxHeight = height + 'px';
        submenu.style.opacity = '1';
        
        submenu.offsetHeight;
        
        requestAnimationFrame(function() {
          submenu.style.maxHeight = '0';
          submenu.style.opacity = '0';
        });
      }
    }

    const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
    
    if (mobileFacetsWrapper) {
      const menuItems = mobileFacetsWrapper.querySelectorAll('.ec-menu-item');
      let isInitialLoad = true;
      
      requestAnimationFrame(function() {
        isInitialLoad = false;
      });
      
      menuItems.forEach(function(menuItem) {
        if (menuItem.hasAttribute('open')) {
          const submenu = menuItem.querySelector('.ec-submenu');
          if (submenu) {
            submenu.style.maxHeight = 'none';
            const height = submenu.scrollHeight;
            submenu.style.maxHeight = height + 'px';
            submenu.style.opacity = '1';
          }
        }
        
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (isInitialLoad) return;
              
              const isOpen = menuItem.hasAttribute('open');
              if (isOpen && mutation.oldValue === null) {
                animateSubmenu(menuItem, true);
              } else if (!isOpen && mutation.oldValue !== null) {
                animateSubmenu(menuItem, false);
              }
            }
          });
        });
        
        observer.observe(menuItem, {
          attributes: true,
          attributeFilter: ['open'],
          attributeOldValue: true
        });
      });
      
      mobileFacetsWrapper.addEventListener('click', function(e) {
        const summaryElement = e.target.closest('summary');
        if (summaryElement && summaryElement.closest('.ec-menu-item')) {
          const detailsElement = summaryElement.parentElement;
          if (detailsElement && detailsElement.tagName === 'DETAILS' && detailsElement.classList.contains('ec-menu-item')) {
            const wasOpen = detailsElement.hasAttribute('open');
            
            if (wasOpen && !e.target.closest('.ec-expandable')) {
              e.preventDefault();
              e.stopPropagation();
              
              const submenu = detailsElement.querySelector('.ec-submenu');
              if (submenu) {
                animateSubmenu(detailsElement, false);
                
                const handleCloseTransition = function(transitionEvent) {
                  if (transitionEvent.propertyName === 'max-height' && transitionEvent.target === submenu) {
                    detailsElement.removeAttribute('open');
                    summaryElement.setAttribute('aria-expanded', 'false');
                    submenu.removeEventListener('transitionend', handleCloseTransition);
                  }
                };
                submenu.addEventListener('transitionend', handleCloseTransition);
                return;
              }
            }
          }
        }
      });

      mobileFacetsWrapper.addEventListener('click', function(e) {
        if (e.target.classList.contains('ec-expandable') || e.target.closest('.ec-expandable')) {
          const expandable = e.target.classList.contains('ec-expandable') 
            ? e.target 
            : e.target.closest('.ec-expandable');
          
          if (expandable) {
            e.preventDefault();
            e.stopPropagation();
            
            const summaryElement = expandable.closest('summary');
            if (summaryElement) {
              const detailsElement = summaryElement.parentElement;
              if (detailsElement && detailsElement.tagName === 'DETAILS') {
                const wasOpen = detailsElement.hasAttribute('open');
                
                if (wasOpen) {
                  const submenu = detailsElement.querySelector('.ec-submenu');
                  if (submenu) {
                    animateSubmenu(detailsElement, false);
                    
                    const handleCloseTransition = function(e) {
                      if (e.propertyName === 'max-height' && e.target === submenu) {
                        detailsElement.removeAttribute('open');
                        summaryElement.setAttribute('aria-expanded', 'false');
                        submenu.removeEventListener('transitionend', handleCloseTransition);
                      }
                    };
                    submenu.addEventListener('transitionend', handleCloseTransition);
                  } else {
                    detailsElement.removeAttribute('open');
                    summaryElement.setAttribute('aria-expanded', 'false');
                  }
                } else {
                  detailsElement.setAttribute('open', '');
                  summaryElement.setAttribute('aria-expanded', 'true');
                  setTimeout(function() {
                    animateSubmenu(detailsElement, true);
                  }, 10);
                }
              }
            }
          }
        }
      });
    }
    
    function animateFacet(detailsElement, isOpening) {
      const display = detailsElement.querySelector('.facets__display');
      if (!display) return;

      detailsElement.classList.remove('ec-opening', 'ec-closing');

      function handleTransitionEnd(e) {
        if (e.propertyName !== 'max-height' && e.propertyName !== 'opacity') return;
        
        if (e.propertyName === 'max-height') {
          detailsElement.classList.remove('ec-opening', 'ec-closing');
          
          if (!detailsElement.hasAttribute('open')) {
            display.style.maxHeight = '';
            display.style.opacity = '';
          }
        }
      }
      
      display.removeEventListener('transitionend', handleTransitionEnd);
      display.addEventListener('transitionend', handleTransitionEnd);

      if (isOpening) {
        detailsElement.classList.add('ec-opening');
        
        display.style.maxHeight = 'none';
        display.style.opacity = '0';
        const height = display.scrollHeight;
        display.style.maxHeight = '0';
        
        display.offsetHeight;
        
        requestAnimationFrame(function() {
          display.style.maxHeight = height + 'px';
          display.style.opacity = '1';
        });
      } else {
        detailsElement.classList.add('ec-closing');
        
        const height = display.scrollHeight;
        display.style.maxHeight = height + 'px';
        display.style.opacity = '1';
        
        display.offsetHeight;
        
        requestAnimationFrame(function() {
          display.style.maxHeight = '0';
          display.style.opacity = '0';
        });
      }
    }

    const facetsContainer = document.querySelector('.facets-container');
    
    if (facetsContainer) {
      const facetDetails = facetsContainer.querySelectorAll('.js-filter');
      let isInitialLoad = true;
      
      requestAnimationFrame(function() {
        isInitialLoad = false;
      });
      
      facetDetails.forEach(function(facetDetail) {
        if (facetDetail.hasAttribute('open')) {
          const display = facetDetail.querySelector('.facets__display');
          if (display) {
            display.style.maxHeight = 'none';
            const height = display.scrollHeight;
            display.style.maxHeight = height + 'px';
            display.style.opacity = '1';
          }
        }
        
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (isInitialLoad) return;
              
              const isOpen = facetDetail.hasAttribute('open');
              if (isOpen && mutation.oldValue === null) {
                animateFacet(facetDetail, true);
              } else if (!isOpen && mutation.oldValue !== null) {
                animateFacet(facetDetail, false);
              }
            }
          });
        });
        
        observer.observe(facetDetail, {
          attributes: true,
          attributeFilter: ['open'],
          attributeOldValue: true
        });
      });

      facetDetails.forEach(function(facetDetail) {
        const summary = facetDetail.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function(e) {
            const wasOpen = facetDetail.hasAttribute('open');
            
            setTimeout(function() {
              const isNowOpen = facetDetail.hasAttribute('open');
              
              if (isNowOpen && !wasOpen) {
                animateFacet(facetDetail, true);
              } else if (!isNowOpen && wasOpen) {
                animateFacet(facetDetail, false);
              }
            }, 10);
          });
        }
      });
    }

    function initRangeSlider() {
			const rangeSliders = document.querySelectorAll('[data-range-slider]')

			rangeSliders.forEach(function (slider) {
				if (slider.dataset.initialized) return
				slider.dataset.initialized = 'true'

				const minInput = slider.closest('.ec-price-facet').querySelector('[data-field-price-min]')
				const maxInput = slider.closest('.ec-price-facet').querySelector('[data-field-price-max]')
				const leftDot = slider.querySelector('[data-range-left]')
				const rightDot = slider.querySelector('[data-range-right]')
				const rangeLine = slider.querySelector('[data-range-line]')

				if (!minInput || !maxInput || !leftDot || !rightDot || !rangeLine) return

				const min = parseFloat(slider.getAttribute('data-se-min')) || 0
				const max = parseFloat(slider.getAttribute('data-se-max')) || 100
				const step = parseFloat(slider.getAttribute('data-se-step')) || 1

				let minValue = parseFloat(slider.getAttribute('data-se-min-value'))
				let maxValue = parseFloat(slider.getAttribute('data-se-max-value'))

				if (isNaN(minValue)) {
					minValue = parseFloat(minInput.value) || min
				}
				if (isNaN(maxValue)) {
					maxValue = parseFloat(maxInput.value) || max
				}

				minValue = Math.max(min, Math.min(minValue, max))
				maxValue = Math.min(max, Math.max(maxValue, min))

				let isDragging = false
				let updateFrame = null
				let inputUpdating = false

				function updateSlider(immediate) {
					const update = function () {
						const range = max - min
						if (range <= 0) {
							rangeLine.style.display = 'none'
							return
						}

						const minPercent = ((minValue - min) / range) * 100
						const maxPercent = ((maxValue - min) / range) * 100

						const clampedMinPercent = Math.max(0, Math.min(100, minPercent))
						const clampedMaxPercent = Math.max(0, Math.min(100, maxPercent))
						const lineWidth = Math.max(0, clampedMaxPercent - clampedMinPercent)

						leftDot.style.left = clampedMinPercent + '%'
						rightDot.style.left = clampedMaxPercent + '%'

						if (lineWidth > 0) {
							rangeLine.style.left = clampedMinPercent + '%'
							rangeLine.style.width = lineWidth + '%'
							rangeLine.style.display = 'block'
						} else {
							rangeLine.style.display = 'none'
						}
					}

					if (immediate || isDragging) {
						update()
					} else {
						if (updateFrame) {
							cancelAnimationFrame(updateFrame)
						}
						updateFrame = requestAnimationFrame(update)
					}
				}

				function updateInputs(silent) {
					if (inputUpdating) return
					inputUpdating = true

					const newMinValue = Math.round(minValue)
					const newMaxValue = Math.round(maxValue)

					if (minInput.value != newMinValue) {
						minInput.value = newMinValue
					}
					if (maxInput.value != newMaxValue) {
						maxInput.value = newMaxValue
					}

					if (!silent) {
						setTimeout(function () {
							inputUpdating = false
							if (minInput.dispatchEvent) {
								minInput.dispatchEvent(new Event('input', { bubbles: true }))
							}
							if (maxInput.dispatchEvent) {
								maxInput.dispatchEvent(new Event('input', { bubbles: true }))
							}
						}, 50)
					} else {
						inputUpdating = false
					}
				}

				function setValueFromPosition(percent, isLeft, immediate) {
					const value = min + (percent / 100) * (max - min)
					const steppedValue = Math.round(value / step) * step

					if (isLeft) {
						minValue = Math.max(min, Math.min(steppedValue, maxValue - step))
					} else {
						maxValue = Math.min(max, Math.max(steppedValue, minValue + step))
					}

					updateSlider(true)
					updateInputs(isDragging)
				}

				function handleDotDrag(dot, isLeft) {
					return function (e) {
						e.preventDefault()
						e.stopPropagation()
						isDragging = true

						const sliderRect = slider.getBoundingClientRect()
						const startX = e.clientX || (e.touches && e.touches[0].clientX)
						if (!startX) return

						const startLeft = parseFloat(dot.style.left) || (isLeft ? 0 : 100)

						function onMove(moveEvent) {
							if (!isDragging) return

							moveEvent.preventDefault()
							const currentX =
								moveEvent.clientX || (moveEvent.touches && moveEvent.touches[0].clientX)
							if (!currentX) return

							const sliderRectCurrent = slider.getBoundingClientRect()
							const deltaX = currentX - startX
							const deltaPercent = (deltaX / sliderRectCurrent.width) * 100
							const newPercent = Math.max(0, Math.min(100, startLeft + deltaPercent))

							setValueFromPosition(newPercent, isLeft, true)
						}

						function onEnd() {
							isDragging = false
							updateInputs(false)

							document.removeEventListener('mousemove', onMove)
							document.removeEventListener('mouseup', onEnd)
							document.removeEventListener('touchmove', onMove)
							document.removeEventListener('touchend', onEnd)
						}

						document.addEventListener('mousemove', onMove, { passive: false })
						document.addEventListener('mouseup', onEnd)
						document.addEventListener('touchmove', onMove, { passive: false })
						document.addEventListener('touchend', onEnd)
					}
				}

				leftDot.addEventListener('mousedown', handleDotDrag(leftDot, true))
				leftDot.addEventListener('touchstart', handleDotDrag(leftDot, true))
				rightDot.addEventListener('mousedown', handleDotDrag(rightDot, false))
				rightDot.addEventListener('touchstart', handleDotDrag(rightDot, false))

				slider.addEventListener('click', function (e) {
					if (isDragging) return

					if (
						e.target === leftDot ||
						e.target === rightDot ||
						e.target === rangeLine ||
						e.target.closest('[data-range-left]') ||
						e.target.closest('[data-range-right]')
					) {
						return
					}

					const sliderRect = slider.getBoundingClientRect()
					const clickX = e.clientX - sliderRect.left
					const clickPercent = (clickX / sliderRect.width) * 100
					const clickValue = min + (clickPercent / 100) * (max - min)

					const distanceToMin = Math.abs(clickValue - minValue)
					const distanceToMax = Math.abs(clickValue - maxValue)

					if (distanceToMin < distanceToMax) {
						setValueFromPosition(clickPercent, true, true)
					} else {
						setValueFromPosition(clickPercent, false, true)
					}
				})

				let inputTimeout = null

				minInput.addEventListener('input', function () {
					if (isDragging || inputUpdating) return

					clearTimeout(inputTimeout)
					inputTimeout = setTimeout(function () {
						const value = parseFloat(minInput.value)
						if (!isNaN(value)) {
							minValue = Math.max(min, Math.min(value, maxValue - step))
							updateSlider(true)
						}
					}, 150)
				})

				maxInput.addEventListener('input', function () {
					if (isDragging || inputUpdating) return

					clearTimeout(inputTimeout)
					inputTimeout = setTimeout(function () {
						const value = parseFloat(maxInput.value)
						if (!isNaN(value)) {
							maxValue = Math.min(max, Math.max(value, minValue + step))
							updateSlider(true)
						}
					}, 150)
				})

				if (!minInput.value && minValue !== min) {
					minInput.value = Math.round(minValue)
				}
				if (!maxInput.value && maxValue !== max) {
					maxInput.value = Math.round(maxValue)
				}

				updateSlider(true)
			})
		}

		initRangeSlider()

		const observer = new MutationObserver(function () {
			initRangeSlider()
		})

		observer.observe(document.body, {
			childList: true,
			subtree: true
		})

		window.initRangeSlider = initRangeSlider

    // Close drawer when clicking the backdrop (outside the inner panel)
    const mobileFacetsBackdrop = document.querySelector('#FacetFiltersFormMobile');
    if (mobileFacetsBackdrop) {
      mobileFacetsBackdrop.addEventListener('click', function(e) {
        if (e.target === mobileFacetsBackdrop) {
          const drawerSummary = document.querySelector('.mobile-facets__open-wrapper');
          if (drawerSummary) drawerSummary.click();
        }
      });
    }

    // Apply button: collect mobile form params and submit before closing drawer
    const applyBtn = document.querySelector('.mobile-facets__apply-btn');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        const form = document.querySelector('#FacetFiltersFormMobile');
        if (form && typeof FacetFiltersForm !== 'undefined') {
          const formData = new FormData(form);
          const searchParams = new URLSearchParams(formData).toString();
          FacetFiltersForm.renderPage(searchParams, null);
        }
        const drawerSummary = document.querySelector('.mobile-facets__open-wrapper');
        if (drawerSummary) drawerSummary.click();
      });
    }

  });
})();

